import {
  LargeHeadingStyled,
  SectionHeaderStyled,
} from "../../../components/custom/texts/texts.styled";
import { Layout, Tabs, TabsProps, Skeleton } from "antd";
import React, { useState, useEffect } from "react";
import GeneralSettingsView from "../generalSettings/generalSettings";
import { Services } from "../servicesAdmin";
import { Users } from "../users";
import { BanksSettings } from "../banksSettings";
import { EmailTemplates } from "../emailTemplates";
import { Sponsors } from "../sponsors";
import { RequestsConfig } from "../requestConfig";
import { ColumnContainer } from "src/components/layout/main-layout/main-layout.styled";
import { Resolutions } from "../resolutions";
import { getSettingsPage } from "../../../Api/content";
import { useLocale } from "../../../i18n/localeContext";
import { ZeroWeekDiscount } from "../zeroWeekDiscount";

const { Content } = Layout;

const Settings: React.FC = () => {
  const { locale } = useLocale();
  const [settingsPage, setSettingsPage] = useState<any>(null);
  const [isLoadingContent, setIsLoadingContent] = useState<boolean>(true);

  useEffect(() => {
    let cancel = false;
    setIsLoadingContent(true);
    getSettingsPage(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          setSettingsPage(data);
          setIsLoadingContent(false);
        }
      })
      .catch(() => {
        if (!cancel) {
          setSettingsPage(null);
          setIsLoadingContent(false);
        }
      });
    return () => {
      cancel = true;
    };
  }, [locale]);

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: (isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : settingsPage?.generalsetting_nb || "Configuraciones generales"),
      children: <GeneralSettingsView />,
    },
    {
      key: "2",
      label: (isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : settingsPage?.service_nb || "Servicios"),
      children: <Services />,
    },
    {
      key: "4",
      label: (isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : settingsPage?.bank_nb || "Bancos"),
      children: <BanksSettings />,
    },
    {
      key: "5",
      label: (isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : settingsPage?.template__nb || "Plantillas"),
      children: <EmailTemplates />,
    },
    {
      key: "6",
      label: (isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : settingsPage?.sponsor__nb || "Patrocinadores"),
      children: <Sponsors />,
    },
    {
      key: "7",
      label: (isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : settingsPage?.application__nb || "Solicitudes"),
      children: <RequestsConfig />,
    },
    {
      key: "8",
      label: (isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : settingsPage?.resolution__nb || "Resoluciones"),
      children: <Resolutions />,
    },
    {
      key: "9",
      label: (isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : settingsPage?.user__nb || "Usuarios"),
      children: <Users />,
    },
    {
      key: "10",
      label: (isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : settingsPage?.zero_week_nb || "Descuentos semana cero"),
      children: <ZeroWeekDiscount />,
    },
  ];

  return (
    <ColumnContainer>
      <SectionHeaderStyled>
        <LargeHeadingStyled>{isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : settingsPage?.title || "Configuraciones"}</LargeHeadingStyled>
      </SectionHeaderStyled>

      <Content style={{ marginTop: "16px" }}>
        <Tabs
          tabBarStyle={{
            justifyContent: "space-between",
            width: "100%",
          }}
          defaultActiveKey="month"
          items={items}
        />
      </Content>
    </ColumnContainer>
  );
};

export default Settings;
